import { StatusMessage } from "./StatusMessage";

export interface StatusAddAction
{
    type: "STATUS_ADD";
    status: StatusMessage;
}

export const statusAdd = (status: StatusMessage): StatusAddAction => ({
    type: "STATUS_ADD",
    status
});

export interface StatusDismissAction
{
    type: "STATUS_DISMISS";
    id: string;
}

export const statusDismiss = (id: string): StatusDismissAction => ({
    type: "STATUS_DISMISS",
    id
});

export type StatusActions = StatusAddAction | StatusDismissAction;


// WEBPACK FOOTER //
// ./src/state/ui/action.ts